module.exports = __webpack_public_path__ + "fonts/Prompt-BlackItalic.498f70dc.ttf";